import {
  parsePermissions,
  hasPermission,
  getAllPermissionKeys,
} from "../../../utils/permissionUtils";

export function useScheduleAccess(userData) {
  const isSystemAdmin = userData?.Role === "System Administrator";
  const perms = isSystemAdmin
    ? getAllPermissionKeys()
    : parsePermissions(userData?.Permission);

  const canAddEditSchedule =
    isSystemAdmin || hasPermission(perms, "ADD_EDIT_SCHEDULE");
  const canViewStudyList =
    isSystemAdmin || hasPermission(perms, "STUDY_LIST");
  const canCreateCapa =
    !!userData && (isSystemAdmin || hasPermission(perms, "ADD_CAPA"));

  return {
    isSystemAdmin,
    canAddEditSchedule,
    canViewStudyList,
    canCreateCapa,
  };
}
